import { createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../api';
import { setMessage } from '../../../redux/slice';

export const doStartPreview = createAsyncThunk('premium-features/startPreview', async (params: any, thunkAPI) => {
  try {
    const { response, error } = await api.startPreview(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doSetPremiumFeatures = createAsyncThunk(
  'premium-features/setPremiunFeatures',
  async (params: { companyId: number; previewEnds?: string; notes?: string; status?: string }, thunkAPI) => {
    try {
      const { response, error } = await api.setPremiumFeatures(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);
export const doContactMe = createAsyncThunk('premium-features/contactMe', async (params: any, thunkAPI) => {
  try {
    const { response, error } = await api.contactMe(params);
    if (!error) {
      thunkAPI.dispatch(setMessage("We'll reach out to you soon!"));
    }
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGetPremiumFeatures = createAsyncThunk(
  'premium-features',
  async (params: { companyId: number }, thunkAPI) => {
    try {
      const { response, error } = await api.getPremiumFeatures(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);
